import { render, staticRenderFns } from "./ReplyResponse.vue?vue&type=template&id=6b36e580&"
import script from "./ReplyResponse.vue?vue&type=script&lang=js&"
export * from "./ReplyResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports